export default {
	'first_name:required': 'First name is required!',
	'last_name:required': 'Last name is required!',
	'name:required': 'Name is required!',
	'message:required': 'Message is required!',
	'privacy_policy:required': 'Privacy policy is required!',
	'email:invalid': 'Invalid email address!',
	'email:required': 'Email address is required!',
	'postal_code:invalid': 'Postal code is invalid!',
	'postal_code:required': 'Postal code is required!',
	'city:required': 'City is required!',
	'address:required': 'Address is required!',
	'street_address:required': 'Address is required!',
	'date_of_birth:required': 'Birth date is required!',
	'accept_terms:required': 'Please accept the terms!',
	'date_of_birth:too_late': 'Family card is available only above age 18!',
	'phone_number:required': 'Phone number is required!',
	'subject:required': 'Subject is required!',
	'biography_hu:required': 'Hungarian language bio is required!',
	'biography_en:required': 'English language bio is required!',
	'contract_type:required': 'Contract type is required!',
	'finished:invalid': 'Diploma megszerzésének éve nem érvényes!',
	'image_profile:invalid': 'Profile picture image is invalid!',
	'image_profile:required': 'Profile picture is required!',
	'url_portfolio:invalid': 'Invalid portfolio URL',
	'finished:required': 'Diploma megszerzésének éve kötelező!',
};
